import { render, staticRenderFns } from "./SelectShop.vue?vue&type=template&id=2a766c0b"
import script from "./SelectShop.vue?vue&type=script&lang=js"
export * from "./SelectShop.vue?vue&type=script&lang=js"
import style0 from "./SelectShop.vue?vue&type=style&index=0&id=2a766c0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports